import { render, staticRenderFns } from "./TodoDeliveryOrder.vue?vue&type=template&id=273a6627&scoped=true&"
import script from "./TodoDeliveryOrder.vue?vue&type=script&lang=js&"
export * from "./TodoDeliveryOrder.vue?vue&type=script&lang=js&"
import style0 from "./TodoDeliveryOrder.vue?vue&type=style&index=0&id=273a6627&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273a6627",
  null
  
)

export default component.exports